import React from "react";

import LinkifiedText from "../../../../components/linkified_text";

export function TranslationLibraryControlDetails(props) {
  const { control } = props;

  if (!control) return <div></div>;

  return (
    <div className="translation-library-control-details">
      <div className="control-details">
        <strong>{control.custom_id}</strong>&nbsp;
        <span className="control-title">{control.title}</span>
        <span> / </span>
        <span className="control-subtitle">{control.subtitle}</span>
      </div>
      <div className="control-description">
        <LinkifiedText text={control.description} />
      </div>
      <div className="control-ids">
        <span className="control-id">
          <label>SYSTEM ID:</label> {control.id}
        </span>
        <span> / </span>
        <span className="custom-id">
          <label>CUSTOM ID:</label> {control.custom_id}
        </span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/translation_library_control_details.js